"use client"

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/Dialog.js"
import { CheckCircle, Clock, Terminal } from "lucide-react"

export function FeaturesModal({ open, onOpenChange, type }) {
  const isImplemented = type === "implemented"
  const isUpcoming = type === "upcoming"
  // const isBeagleMind = type === "beaglemind"

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1e1e1e] border-border/40 text-sm max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            {isImplemented ? (
              <>
                <CheckCircle className="h-5 w-5 text-green-500" />
                What's Implemented
              </>
            ) : isUpcoming ? (
              <>
                <Clock className="h-5 w-5 text-orange-400" />
                Upcoming Features
              </>
            ) : (
              <>
                <Terminal className="h-5 w-5 text-[#f5a623]" />
                BeagleMind - Local AI Assistant
              </>
            )}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-xs">
            {isImplemented
              ? "Current features of the BeagleBoard Assistant"
              : isUpcoming
                ? "Features planned for future releases"
                : "A local AI assistant for your BeagleBoard projects"}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {isImplemented ? (
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 mt-0.5 shrink-0" />
                <span>Scraped the documentation repository from OpenBeagle (docs.beagleboard.io) using gitingest</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 mt-0.5 shrink-0" />
                <span>Embedded the data using OpenAI's ADA model</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 mt-0.5 shrink-0" />
                <span>Stored the embeddings in ChromaDB vector database</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="h-4 w-4 text-green-500 mt-0.5 shrink-0" />
                <span>
                  Used LLaMA 3.3 (via the Groq Cloud API for fast inference) to create a chatbot that guides users
                  through BeagleBoard documentation
                </span>
              </li>
            </ul>
          ) : isUpcoming ? (
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Clock className="h-4 w-4 text-orange-400 mt-0.5 shrink-0" />
                <span>Add memory to the chatbot</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="h-4 w-4 text-orange-400 mt-0.5 shrink-0" />
                <span>Finetune LLM for faster inference</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="h-4 w-4 text-orange-400 mt-0.5 shrink-0" />
                <span>
                  Develop a documentation for the chatbot itself as I'm planning to make a package to be published in
                  BeagleBoard Linux distributions
                </span>
              </li>
            </ul>
          ) : (
            <div className="space-y-6">
              <div>
                <h3 className="text-md font-medium text-[#f5a623] mb-2">About BeagleMind</h3>
                <p className="text-muted-foreground">
                  BeagleMind is a powerful local AI assistant designed specifically for BeagleBoard. It runs entirely on
                  your BeagleBoard device, providing coding assistance, troubleshooting, and project guidance without
                  requiring an internet connection.
                </p>
              </div>

              <div>
                <h3 className="text-md font-medium text-[#f5a623] mb-2">Usage Examples</h3>
                <div className="space-y-3">
                  <div className="rounded-md bg-[#121212] p-3">
                    <p className="text-xs font-mono text-muted-foreground">
                      <span className="text-green-400">$</span> beaglemind -p 'hi, how to blink an LED using
                      BeagleBoard'
                    </p>
                  </div>
                  <div className="rounded-md bg-[#121212] p-3">
                    <p className="text-xs font-mono text-muted-foreground">
                      <span className="text-green-400">$</span> beaglemind -p 'hi, my code is showing some errors' --log
                      'path/to/error.log'
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

